export default {
    index: {
        title: 'Gift cards',
        intro: 'Cadeaubonnen for {website}.',
        noWebsite: 'Select a website first to manage its gift cards.',
    },
    status: {
        disabled: 'Disabled',
        expired: 'Expired',
        spent: 'Spent',
        partSpent: 'Part spent',
        unused: 'Unused',
    },
    delivery: {
        sent: 'Sent {date}',
        scheduled: 'Scheduled {date}',
        notSent: 'Not sent',
    },
    panel: {
        intro: 'Cadeaubonnen sold in the shop, plus any you issue by hand.',
        outstanding: 'Outstanding balance: {amount}.',
        issueCard: 'Issue a card',
        issueTitle: 'Issue a gift card',
        issueHelp: 'For a card nobody paid for: goodwill after a complaint, a promotion, or a physical card sold over the counter. It works exactly like a bought one. Nothing is emailed until you press Send on the row.',
        amountHint: 'In euros, e.g. 50 or 12.50.',
        recipientName: 'Recipient name',
        recipientNameHint: 'Optional. Used in the greeting.',
        recipientEmail: 'Recipient email',
        recipientEmailPlaceholder: "oma{'@'}example.com",
        recipientEmailHint: 'Optional. Leave blank for a card you hand over.',
        issue: 'Issue card',
        empty: 'No gift cards yet. They appear here as customers buy them, or you can issue one by hand.',
        balance: 'Balance',
        for: 'For',
        delivery: 'Delivery',
        enabled: 'Enabled',
        ofInitial: 'of {amount}',
        ledger: 'Where the money went',
        sendByEmail: 'Send this card by email',
        created: 'Gift card created',
        confirmSendTo: 'Send gift card {code} to {to} now?',
        confirmSend: 'Send gift card {code} to its recipient now?',
        sent: 'Gift card sent',
    },
    ledger: {
        title: 'Card {code}',
        issued: 'Issued',
        byHand: '(by hand)',
        boughtBy: 'Bought by',
        expires: 'Expires',
        never: 'Never',
        nothingSpent: 'Nothing spent yet: the full {amount} is still on the card.',
        when: 'When',
        order: 'Order',
        spent: 'Spent',
        leftAfter: 'Left after',
        held: 'held, awaiting payment',
        released: 'returned {date}',
    },
};
